<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
      <template #header>
        <div class="d-flex align-items-center">
          <strong class="mr-auto">Operational Dashboard</strong>
        </div>
      </template>

      <b-row class="pb-3" style="border-bottom: 3px solid grey;">
        <div id="listloader" v-if="loader">
          <div class="listloader"></div>
        </div>


        <!-- LEFT SIDE (md-8) -->
        <b-col md="9">

          <!-- ROW 1 -->
          <b-row class="">
            <b-col md="6">
              <b-form-group
                label="Select Origin WH"
                label-cols="5"
                label-align="right"
                
              > 
                 <ejs-multiselect id="multi_select2"
                    name="warehouse" placeholder="Select WareHouse" v-model="valueWH"
                    :dataSource="optionsWH" :showSelectAll="showSelectAll" selectAllText="Select All"
                    unSelectAllText="unSelect All" :fields="fieldWH"
                    :allowCustomValue="allowCustomValue" enableGroupCheckBox="true"
                    mode="CheckBox">
                 </ejs-multiselect>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Select Hub"
                label-cols="4"
                label-align="right"
                
              >
                  <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWHhub" :dataSource='optionsWHhub' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                  >
                </ejs-multiselect>
                            
              </b-form-group>
            </b-col>

          </b-row>

          <!-- ROW 2 -->
          <b-row class="">

            <b-col md="4">
              <b-form-group
                label="EDD"
                label-cols="4"
                label-align="right"
                
              >
                <b-form-select 
                  :options="eddOptions"
                  v-model="filters.edd"/>
              </b-form-group>
            </b-col>

            <b-col md="5">
              <b-form-group
                label="Shipment Journey"
                label-cols="6"
                label-align="right"
             
              >
                <b-form-select 
                  :options="journeyOptions"
                  v-model="filters.journey"/>
              </b-form-group>
            </b-col>

             <b-col class="text-right" md="3">
              <b-button  variant="primary" class="mr-2" @click="search()">
                Search
              </b-button>
              <b-button  variant="danger" @click="clear()">
                Clear
              </b-button>
            </b-col>


           

          </b-row>

          <!-- BUTTON ROW -->
          <b-row class="mt-2">
           
          </b-row>

        </b-col>

        <!-- RIGHT SIDE (md-4) -->
        <b-col md="3" class="clickable">
          <router-link to="/vehiclemovement" style="text-decoration: none;">
          <div class="summary-box text-center " >
            <div class="title">Vehicle Movement Today</div>

            <div class="d-flex justify-content-around mt-3">
              <div><strong>Direct</strong><br>25</div>
              <div><strong>PickUp</strong><br>5</div>
              <div><strong>LH</strong><br>12</div>
              <div><strong>NLH</strong><br>2</div>
            </div>
          </div>
         </router-link>

        </b-col>

      </b-row>

      <!-- SHIPMENT SUMMARY CARDS -->
    <div class="overallproctshipment">
        <div class="d-flex align-items-center p-2">
            <strong class="mr-auto">Overall RocketBees Shipments</strong>
        </div>
        <b-row class="mt-3 text-center">
          <b-col 
            v-for="(item, index) in summaryList" 
            :key="index"
          >
            <div 
              class="shipment-box"
              :class="{ clickable: item.value > 0, disabled: !item.value || Number(item.value) === 0 }"
              :style="{ backgroundColor: item.color }"
              @click="item.value > 0 && handleCardClick(item)"
            >
              <div class="title">{{ item.title }}</div>
              <div class="value">{{ item.value ? item.value : 0 }}</div>
            </div>
          </b-col>
        </b-row>

        <!-- DRILLDOWN SECTION -->
        <div v-if="showHubSection && (keyword == 'TodaysDelivered')" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ firsttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false; showHubSectioncitywise = false ">
                Close
                </b-button>
            </div>

            <b-row class="text-center hub-scroll-container">

                <b-col 
                v-for="(hub, index) in hubList" 
                :key="index" 
                md="3"
                class="mb-2"
                >
          
                <div class="hub-box clickable"
                @click="handleCardClickforcity(hub)">
                    <div class="hub-title">{{ hub.name }}</div>
                    <div  class="hub-value" 
                 :class="{ 'text-danger': hub.count > 0, 'text-bold': 800 }">{{ hub.count }}</div>
                </div>
                </b-col>
            </b-row>

        </div>

        <div v-if="showHubSection && (keyword == 'TodayinReturnJourney')" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ firsttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false; showHubSectioncitywise = false ">
                Close
                </b-button>
            </div>

            <b-row class="text-center hub-scroll-container">

                <b-col 
                v-for="(hub, index) in hubList" 
                :key="index" 
                md="3"
                class="mb-2"
                >
          
                <div class="hub-box clickable"
                @click="handleCardClickforcity(hub)">
                    <div class="hub-title">{{ hub.name }}</div>
                    <div  class="hub-value" 
                 :class="{ 'text-danger': hub.count > 0, 'text-bold': 800 }">{{ hub.count }}</div>
                </div>
                </b-col>
            </b-row>

        </div>

         <div v-if="showHubSection && (keyword == 'Todayinfirstfile')" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ firsttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false; showHubSectioncitywise = false ">
                Close
                </b-button>
            </div>
            
            <b-row class="text-center hub-scroll-container">
              <!-- {{ firstfilecount }} -->
                <b-col 
                v-for="(first, index) in firstfilecount" 
                :key="index" 
                md="3"
                class="mb-2"
                >
          
                <div class="hub-box clickable">
                  <router-link 
                    :to="{
                      path: '/shipmentsdispatched',
                      query: { 
                        city: first.name, 
                        keyword: first.id,
                        hubid: first.id,
                        mainkeyword: keyword,
                       
                      },
                    
                    }"
                    style="text-decoration: none !important; color:black;"
                  >
                    <div class="hub-title">{{ first.name }}</div>
                    <div  class="hub-value" 
                 :class="{ 'text-danger': first.count > 0, 'text-bold': 800 }">{{ first.count }}</div>
                </router-link>
                </div>
                </b-col>
            </b-row>

        </div>

        <div v-if="showHubSection && (keyword == 'TodayinMidMile' || keyword == 'TodayinLastMile')" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ firsttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false; showHubSectioncitywise = false ">
                Close
                </b-button>
            </div>
            
            <b-row class="text-center hub-scroll-container">
              <!-- {{ mid_lastmilecounts }} -->
                <b-col 
                v-for="(midmile, index) in mid_lastmilecounts" 
                :key="index" 
                md="3"
                class="mb-2"
                >
          
                <div class="hub-box clickable"
                @click="handleCardClickmidlastmile(midmile)">
                
                  
                    <div class="hub-title">{{ midmile.name }}</div>
                    <div  class="hub-value" 
                 :class="{ 'text-danger': midmile.count > 0, 'text-bold': 800 }">{{ midmile.count }}</div>
               
                </div>
                </b-col>
            </b-row>

        </div>

        <div v-if="showHubSectionmidmile && (keyword != 'TodayinMidMile' && keyword != 'TodayinLastMile')" class="mt-4 hub-section" >
          <!-- {{ citywisedata }} -->
            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ secondtitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSectioncitywise = false">
                Close
                </b-button>
            </div>

            <b-row class="text-center">
               <b-col 
                  v-for="(destcity, index) in citywisedata" 
                  :key="index" 
                  md="3"
                  class="mb-2"
                >
                <div class="hub-box" >
             <router-link 
                    :to="{
                      path: '/shipmentsdispatched',
                      query: { 
                        city: destcity.name, 
                        keyword: selectedhibid,
                        hubid: keyword == 'TodayinReturnJourney' ? destcity.id : selectedhibid,
                        mainkeyword: keyword,
                       
                      },
                    
                    }"
                    style="text-decoration: none !important; color:black;"
                  >
                    <div class="hub-title">{{ destcity.name }}</div>
                    <div class="hub-value">{{ destcity.count }}</div>
                     </router-link>
                </div>
               
                </b-col>
            </b-row>

        </div>
        <!-- FOR MIDMILE AND LASTMILE -->
         <div v-if="showHubSectionmidmile && (keyword == 'TodayinMidMile' || keyword == 'TodayinLastMile')" class="mt-4 hub-section" >
              
            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ secondtitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSectioncitywise = false">
                Close
                </b-button>
            </div>

            <b-row class="text-center">
              <!-- {{ citywisedata }} -->
               <b-col 
                  v-for="(destcity, index) in citywisedata" 
                  :key="index" 
                  md="3"
                  class="mb-2"
                >
                <div class="hub-box" >
             <router-link 
                    :to="{
                      path: '/shipmentsdispatched',
                      query: { 
                        city: destcity.name, 
                        keyword: selectedhibid,
                        hubid: destcity.id,
                        mainkeyword: keyword,
                       
                      },
                    
                    }"
                    style="text-decoration: none !important; color:black;"
                  >
                    <div class="hub-title">{{ destcity.name }}</div>
                    <div class="hub-value">{{ destcity.count }}</div>
                     </router-link>
                </div>
               
                </b-col>
            </b-row>

        </div>


        <!-- DRILLDOWN SECTION -->
        <div v-if="showHubSectioncitywise" class="mt-4 hub-section" >
          <!-- {{ citywisedata }} -->
            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ secondtitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSectioncitywise = false">
                Close
                </b-button>
            </div>
           <!-- {{citywisedata}} -->
            <b-row class="text-center">
               <b-col 
                  v-for="(destcity, index) in citywisedata" 
                  :key="index" 
                  md="3"
                  class="mb-2"
                >
                <div class="hub-box" >
             <router-link 
                    :to="{
                      path: '/shipmentsdispatched',
                      query: { 
                        city: destcity.name, 
                        keyword: selectedhibid,
                        hubid: keyword == 'TodayinReturnJourney' ? destcity.id : selectedhibid,
                        mainkeyword: keyword,
                       
                      },
                    
                    }"
                    style="text-decoration: none !important; color:black;"
                  >
                    <div class="hub-title">{{ destcity.name }}</div>
                    <div class="hub-value">{{ destcity.count }}</div>
                     </router-link>
                </div>
               
                </b-col>
            </b-row>

        </div>

    </div>
    <div>
        <div class="d-flex align-items-center p-2 mt-2">
            <strong class="mr-auto">InTransit</strong>
        </div>
    <b-row class="mt-2 text-center">
        
        <b-col>
            <div class="top-tile">
            <div class="tile-title">Forward Shipment InTransit</div>
            <div class="tile-value">{{ this.intransitcount && this.intransitcount.forwardintransitcount  || 0}}</div>
            </div>
        </b-col>

        <b-col>
            <div class="top-tile">
            <div class="tile-title">RTO Shipment InTransit</div>
            <div class="tile-value">{{ this.intransitcount && this.intransitcount.rtointransitcount  || 0 }}</div>
            </div>
        </b-col>

        <b-col>
            <div class="top-tile">
            <div class="tile-title">PickUp Shipment</div>
            <div class="tile-value">{{this.intransitcount && this.intransitcount.pickdoneintransitcount || 0 }}</div>
            </div>
        </b-col>

        

    </b-row>
    </div>
   <div class="mt-3" v-for="(section, sIndex) in sections" :key="sIndex">

      <!-- ACCORDION ROW -->
      <div class="accordion-row" @click="toggleSection(sIndex, section)">

        <!-- LEFT -->
        <div class="left-section">
          <span class="label text-danger bold-text">{{ section.title }}</span>
          <span class="arrow">
            {{ section.open ? '▼' : '▶' }}
          </span>
        </div>

        <!-- RIGHT METRICS -->
        <div class="right-section">
          <div 
            class="count-box-inline"
            v-for="(metric, mIndex) in section.metrics"
            :key="mIndex"
          >
            <div class="metric-title">{{ metric.label }}</div>
            <div class="metric-value">{{ metric.value }}</div>
          </div>
        </div>

      </div>

      <!-- TABLE -->
      <div v-if="section.open" class="table-section">

        <table class="custom-table">

          <thead>
            <tr>
              <th v-for="(col, cIndex) in section.tableColumns" :key="cIndex">
                {{ col.label }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(row, rIndex) in section.tableData" :key="rIndex">

              <td v-for="(col, cIndex) in section.tableColumns" :key="cIndex">

                <!-- ORIGIN -->
                <span v-if="col.key === 'origin'">
                  {{ row[col.key] }}
                </span>

                <!-- CLICKABLE COUNT -->
                <span 
                  v-else-if="row[col.key] !== '-' && Number(row[col.key]) > 0"
                  class="clickable1"
                  @click.stop="openPopup(section.type, col.key, row)"
                >
                  {{ row[col.key] }}
                </span>

                <!-- ZERO / DASH -->
                <span v-else>
                  {{ row[col.key] === 0 ? 0 : '-' }}
                </span>

              </td>

            </tr>
          </tbody>

        </table>

        <b-col md="12" class="my-1" v-if="totalRows > 0">
          <paginate 
            v-model="pageNum"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback1"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </b-col>

      </div>

    </div>

    

    </b-card>

    <b-modal v-model="showModal" title="AWB Details" size="lg">

        <b-button size="sm" variant="primary" class="mb-2 float-right" v-if="awbData && awbData.length > 0" @click="getorigindetailCsvdata();">
        Download CSV
        </b-button>

        <b-table 
        :items="awbData"
        :fields="awbFields"
        small
        bordered
        ></b-table>

         <b-col md="12" class=" " v-if="totalRowsmodal > 0">
            <paginate 
            v-model="pageNum1"
            :page-count="noofpagesmodal"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback2"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
        </b-col>

    </b-modal>
  </div>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default {
  data() {
    return {
        optionsWH  :[],
        valueWH :[],
        fieldWH: { text: "name", value: "id" },
        WHdata:[],
        WHDatahub:[],
        optionsWHhub  :[],
        valueWHhub:[],
         showSelectAll : true,
      filters: {
        origin: null,
        hub: null,
        edd: null,
        journey: null
      },
      hubOptions: [
        { value: null, text: '-- Select Hub --' }
      ],

      eddOptions: [
        { value: null, text: '-- Select Status --' },
        { value: 'TodayEDD', text: 'Today`s EDD' },
        { value: 'TomorrowEDD', text: 'Tomorrow`s EDD' },
        { value: 'FutureEDD', text: 'Future`s EDD' },
        { value: 'EDDBreached', text: 'EDD Breached' }
      ],

      journeyOptions: [
        { value: null, text: '-- Select Status --' },
        { value: 'ForwardJourney', text: 'Forward Journey' },
        { value: 'ReverseJourney', text: 'Reverse Journey' },
        { value: 'PickUpJourney', text: 'PickUp Journey' },
      ],
      summaryList: [
      { key: "TodaysDelivered", title: "Today's Delivered", value: '',  color: "#17a2b8" },
      { key: "TodayinLastMile", title: "Today in Last Mile", value: 0, color: "#28a745" },
      { key: "TodayinMidMile",  title: "Today in Mid Mile", value: 0,  color: "#ffc107"  },
      { key: "Todayinfirstfile", title: "Today in First Mile", value: 0, color: "#dc3545" },
      { key: "TodayinReturnJourney", title: "Today in Return Journey",  value: 0, color: "#17a2b8" }
      ],

    hubList: [],
    hubCountMap: {},

    showHubSection:false,
    showHubSectioncitywise:false,
        showFirstMile: false,
    showModal: false,

    perPage: 20,
    currentPage: 1,

    firstMileCounts: [
      { label: "BookingPending", value: 0 },
      { label: "BookingDone", value: 0 },
      { label: "HubInScanPending", value: 0 },
      { label: "PickDone", value: 0 },
      { label: "NPR", value: 0 }
    ],

    fields: [
      { key: "origin", label: "Origin Name" },
      { key: "bookingPending", label: "Booking Pending" },
      { key: "bookingDone", label: "Booking Done" },
      { key: "hubScan", label: "HubInScan Pending" },
      { key: "pickDone", label: "PickDone" },
      { key: "npr", label: "NPR" }
    ],

    tableData: [
      {
        origin: "BLR WH",
        bookingPending: 5,
        bookingDone: 6,
        hubScan: 18,
        pickDone: "-",
        npr: "-"
      },
      {
        origin: "Pune WH",
        bookingPending: 23,
        bookingDone: 23,
        hubScan: 33,
        pickDone: "-",
        npr: "-"
      }
    ],

    awbFields: [
      { key: "parentawb", label: "Parent AWB" },
      { key: "load_id", label: "Load ID" },
      { key: "mpscount", label: "MPS Count" },
      {
          key:'createddate',
          label:'Created Date',
          formatter: value => value ? new Date(value).toLocaleDateString('en-IN') : '',
          tdClass: 'text-nowrap'
      },
      { key: "shipmentstatus", label: "Shipment Status" },
      { key: "lastdisptchhubname", label: "Hub Name" }
    ],

    awbData: [],
    sections: [

      {
        type: "firstmile",
        title: "Firstmile Movement",
        open: false,
        metrics: [],
        tableColumns: [
          { key: "origin", label: "Origin Name" },
          { key: "BookingPending", label: "Booking Pending" },
          { key: "BookingDone", label: "Booking Done" },
          { key: "HubInScanPending", label: "HubInScan Pending" },
          { key: "PickDone", label: "PickDone" },
          { key: "NPR", label: "NPR" }
        ],
        tableData: [],
        dataLoaded: false
      },

      {
        type: "midmile",
        title: "Midmile Movement",
        open: false,
        metrics: [],

        tableColumns: [
          { key: "origin", label: "Hub Name" },
          { key: "HubInScan", label: "HubInScan" },
          { key: "ZoneInScan", label: "ZoneInScan/DockInScan" },
          { key: "ZoneOutScan", label: "ZoneOutScan/DockOutScan" },
          { key: "DispatchOutScan", label: "DispatchOutScan" },
          { key: "INTransit", label: "INTransit" }
        ],

        tableData: [],
        intransitcount:[],
        dataLoaded: false
      },
      {
        type: "lastmile",
        title: "Lastmile Movement",
        open: false,
        metrics: [],

        tableColumns: [
          { key: "origin", label: "Hub Name" },
          { key: "HubInScan", label: "HubInScan" },
          { key: "ZoneInScan", label: "ZoneInScan" },
          { key: "ZoneOutScan", label: "ZoneOutScan" },
          { key: "DispatchOutScan", label: "DispatchOutScan" },
          { key: "partialDLV", label: "partialDLV" },
          { key: "OFD", label: "OFD" },
          { key: "NDR", label: "NDR" },
         
        ],
        dataLoaded: false,
        tableData: [],
        intransitcount:[]
      },
      // rtomovement
       {
        type: "rtomovement",
        title: "RTO Movement",
        open: false,
        metrics: [],
        tableColumns: [
           { key: "origin", label: "Hub Name" },
          { key: "RTO", label: "RTO" },
          { key: "RTO_DLV", label: "RTO_DLV" },
          { key: "RTODispatchOutScan", label: "RTODispatchOutScan" },
          { key: "RTOHubInScan", label: "RTOHubInScan" },
          { key: "RTOINTransit", label: "RTOINTransit" },
          { key: "RTOOFD", label: "RTOOFD" },
          { key: "RTOZoneInScan", label: "RTOZoneInScan" },
          { key: "RTOZoneOutScan", label: "RTOZoneOutScan" },
        ],

        dataLoaded: false,
        tableData: [],
        intransitcount:[]
      }

    ],
    userType:"",
    Usersysuserid:"",
    user_id:"",
    route_id: null,
    deliverycount:{},
    citywisedata:{},
    selectedhibid:'',
    keyword:'',
    firsttitle:'',
    secondtitle:'',
    firstfilecount:0,
    loader:false,
    showHubSectionmidmile:false,
    midmileData: [],
    lastmileData: [],
    mid_lastmilecounts: [],
    pageNum:1,
    pageNum1:1,
    noofpages:'',
     totalRows: 0,
       sectionType:'',
       rowhubid:'',
    totalRowsmodal:0,
    noofpagesmodal:'',
  columnKey:'',
  roworigin:'',
  selectedparetawb:[],

    }
  },

  created(){
    
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.userType=userInfo.user_type;
    this.Usersysuserid=userInfo.sysusermasterid;
    this.user_id = userInfo.sysusermasterid;
    this.route_id = this.$route.params.id || 'normal'
    this.getwarehousedetails();
    this.showWHlist();
    this.getdashboarddeliverycount();
    this.getdashboardreturnjourneycount();
    this.getfirstmiletodayscount();
    this.getmidmiletodayscount();
    this.getintransitcount();
    this.getlastmiletodayscount();
  },

  methods: {
  search() {
    this.getdashboarddeliverycount();
    this.getdashboardreturnjourneycount();
    this.getfirstmiletodayscount();
      this.getmidmiletodayscount();
      this.getintransitcount();
      this.getlastmiletodayscount();
    this.showHubSection = false
  },
  clear() {
    this.filters = {
      origin: null,
      hub: null,
      edd: null,
      journey: null
    },
    this.valueWHhub=[],
    this.valueWH=[]
    this.showHubSection = false
    this.getdashboarddeliverycount();
    this.getdashboardreturnjourneycount();
    this.getfirstmiletodayscount();
    this.getmidmiletodayscount();
    this.getintransitcount();
    this.getlastmiletodayscount();
  },

  handleCardClick(item) {
      // console.log(item.title )
      this.keyword = item.key
      
    if (item) {
      this.showHubSection = true
      this.showHubSectionmidmile = false
      if(this.keyword == 'TodaysDelivered' ){

        this.firsttitle = 'Delivered Shipments - Hubwise Dispatch'
        this.getshipementcountfortodaydelivery();
      }
      if(this.keyword == 'TodayinReturnJourney'){
          this.firsttitle = 'RTO Journey Shipment Details'
          this.getshipementcountfortodayreturnjourney();
      }
      if(this.keyword == 'Todayinfirstfile'){
        this.firsttitle = 'Firstmile - Shipment Details'
        this.getfirstmileshipmentcountdetails(this.keyword= "Todayinfirstfile");
      }
      if (this.keyword == 'TodayinMidMile') {
      this.firsttitle = 'Midmile Shipment Details';

        this.mid_lastmilecounts = this.midmileData.map(status => ({
          name: status.status_name,
          count: status.status_count,
          hubs: status.hubs
        }));

      } 
      if (this.keyword == 'TodayinLastMile') {
        this.firsttitle = 'Lastmile  Shipment Details';

        this.mid_lastmilecounts = this.lastmileData.map(status => ({
          name: status.status_name,
          count: status.status_count,
          hubs: status.hubs
        }));
      }
      
    } else {
      this.showHubSection = false
      this.showHubSectionmidmile= false
    }
  },

  handleCardClickforcity(item){
    this.selectedhibid = item.id
    if(this.keyword == 'TodaysDelivered'){    
      this.secondtitle = 'Delivered Shipments - Hubwise Dispatch, Citywise Delivery'
    }
    else if(this.keyword == 'TodayinReturnJourney'){
      this.secondtitle = 'RTO Journey - Hubwise'
    }
    if (item) {
      this.showHubSectioncitywise = true
      this.getcitywisecounttodaydelivery(item.id);
    } else {
      this.showHubSectioncitywise = false
    }
  },

  handleCardClickmidlastmile(item) {
    if (!item) return;
    // alert()
    // console.log(item);
    
    this.showHubSectionmidmile = true;
    if(this.keyword == 'TodayinMidMile'){
        this.secondtitle = 'Midmile Shipment Details - Hubwise';
    }
    else{
        this.secondtitle = 'Lastmile Shipment Details - Hubwise';
    }
    

    // store selected status (optional, for routing)
    this.selectedhibid = item.name;

    // Map hubs → citywisedata
    this.citywisedata = (item.hubs || [])
      .map(hub => ({
        name: this.getHubName(hub.hubname), //  use your mapping function
        count: hub.hubcount,
        id: hub.hubname
      }))
      .filter(hub => hub.count > 0); // remove zero counts
  },
  getHubName(hubId) {
    // console.log("hubId", hubId);
    // console.log("this.WHDatahub", this.WHDatahub);
    
    
    if (!this.WHDatahub || !this.WHDatahub.length) {
      return "Hub-" + hubId;
    }

    const hub = this.WHDatahub.find(
      h => String(h.hub_id) === String(hubId)
    );

    return hub && hub.hub_title ;
  },

  // openPopup(item) {
  //     // console.log("Clicked:", item.label)
  //     this.showModal = true
  // },
  toggleSection(index, section) {

    //  Check if all metric values are 0
    const allZero = section.metrics.every(m => Number(m.value) === 0);

    // 🚫 If all zero → do nothing (don't open)
    if (allZero) {
      return;
    }

    const isOpening = !section.open;

    // Close others
    this.sections.forEach((sec, i) => {
      if (i !== index) {
        sec.open = false;
      }
    });

    // Toggle current
    this.sections[index].open = isOpening;

    if (!isOpening) return;

    if (section.dataLoaded) return;

    section.dataLoaded = true;

    this.selectedtype = section.type;

    if (this.selectedtype === 'lastmile') {
      this.getmovementlastmileshipmentdatacount(this.pageNum);
    } 
    else if (this.selectedtype === 'midmile') {
      this.getmovementmidmileshipmentdatacount(this.pageNum);
    } 
    else {
      this.getmovementnameandshipmentdatacount(this.selectedtype, this.pageNum);
    }
  },


  getmovementmidmileshipmentdatacount(pageNum) {
    // alert()
  const obj = {
    hub_id: this.valueWHhub,
    warehouseid: this.valueWH,
    edd: this.filters.edd,
    shipmentjourney: this.filters.journey,
    // keyword: type,
    page_no: pageNum,
  };

  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmovementmidmileshipmentdatacount`, obj)
    .then(result => {
      if (result.data.returnmsg === 'Successful') {
        this.totalRows = result.body.returnvalue.totalcount
        console.log("this.totalRows", this.totalRows);
        
        this.noofpages=parseInt(this.totalRows)/10;
        this.noofpages=Math.ceil( this.noofpages);
        let mappedData = result.data.returnvalue.midmile.map(item => ({
          origin: item.hubname,   // FIXED
          currenthubid: item.hub,
          HubInScan: Number(item.HubInScan) || 0,
          ZoneInScan: Number(item.ZoneInScan) || 0,
          ZoneOutScan: Number(item.ZoneOutScan) || 0,
          DispatchOutScan: Number(item.DispatchOutScan) || 0,
          INTransit: Number(item.INTransit) || 0,
          parentawb: (item.parentawb)
        }));

        console.log("mappedData", mappedData);

        this.sections.find(s => s.type === "midmile").tableData = mappedData;
      }
    });
  },


  getmovementlastmileshipmentdatacount(pageNum){
    const obj = {
    hub_id: this.valueWHhub,
    warehouseid: this.valueWH,
    edd: this.filters.edd,
    shipmentjourney: this.filters.journey,
    // keyword: type,
    page_no: pageNum,
  };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmovementlastmileshipmentdatacount`, obj)
    .then(result => {
      if (result.data.returnmsg === 'Successful') {
        console.log("result.body.returnvalue fir inner firstmile", result.body.returnvalue);
        
        this.totalRows = result.body.returnvalue.totalcount
        console.log("this.totalRows", this.totalRows);
        
        this.noofpages=parseInt(this.totalRows)/10;
        this.noofpages=Math.ceil( this.noofpages);
        let mappedData = result.data.returnvalue.lastmile.map(item => ({
          origin: item.hubname,   // FIXED
          currenthubid: item.hub,
          HubInScan: Number(item.HubInScan) || 0,
          ZoneInScan: Number(item.ZoneInScan) || 0,
          ZoneOutScan: Number(item.ZoneOutScan) || 0,
          DispatchOutScan: Number(item.DispatchOutScan) || 0,
          partialDLV: Number(item.partialDLV) || 0,
          OFD: Number(item.OFD) || 0,
          NDR: Number(item.NDR) || 0,
          parentawb:(item.parentawb)
        }));



        console.log("mappedData", mappedData);

        this.sections.find(s => s.type == "lastmile").tableData = mappedData;
      }
    })

  },

  getmovementnameandshipmentdatacount(type, pageNum) {
  const obj = {
    hub_id: this.valueWHhub,
    warehouseid: this.valueWH,
    edd: this.filters.edd,
    shipmentjourney: this.filters.journey,
    keyword: type,
    page_no: pageNum,
  };

  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmovementnameandshipmentdatacount`, obj)
    .then(result => {
      if (result.data.returnmsg === 'Successful') {
        this.totalRows = result.body.returnvalue[0].totalcount
        console.log("this.totalRows", this.totalRows);
        
        this.noofpages=parseInt(this.totalRows)/10;
        this.noofpages=Math.ceil( this.noofpages);
        let mappedData =[];
        if(type == 'firstmile'){
          mappedData = result.data.returnvalue.map(item => ({
            origin: item.origin,
            
            BookingPending: Number(item.BookingPending) || 0,
            BookingDone: Number(item.BookingDone) || 0,
            HubInScanPending: Number(item.HubInScanPending) || 0,
            PickDone: Number(item.PickDone) || 0,
            NPR: Number(item.NPR) || 0
          }));

        }
        if(type =='rtomovement'){
           mappedData = result.data.returnvalue.map(item => ({
            origin: item.lastdisptchhubname,
            currenthubid: item.currenthubid,
            RTO: Number(item.RTO) || 0,
            RTO_DLV: Number(item.RTO_DLV) || 0,
            RTODispatchOutScan: Number(item.RTODispatchOutScan) || 0,
            RTOHubInScan: Number(item.RTOHubInScan) || 0,
            RTOINTransit: Number(item.RTOINTransit) || 0,
            RTOOFD: Number(item.RTOOFD) || 0,
            RTOZoneInScan: Number(item.RTOZoneInScan) || 0,
            RTOZoneOutScan: Number(item.RTOZoneOutScan) || 0
          }));

        }

        const section = this.sections.find(s => s.type == type);

        if (section) {
          section.tableData = mappedData;
        }
      }
    });
  },

  clickCallback1 (pageNum){
      this.getmovementnameandshipmentdatacount(this.selectedtype, pageNum);
  },
  clickCallback2(pageNum1){
    this.getorigindetaildata( this.sectionType,this.columnKey, this.roworigin,pageNum1, this.rowhubid )
     
  },


  openPopup(sectionType, columnKey, row) {
    this.sectionType =sectionType
    this.columnKey= columnKey
    this.roworigin = row.origin
    this.rowhubid = row.currenthubid
    // this.selectedparetawb =  row.parentawb
   if (
      row.parentawb &&
      row.parentawb[this.columnKey] &&
      Array.isArray(row.parentawb[this.columnKey])
    ) {
      this.selectedparetawb = row.parentawb[this.columnKey];
    }
    console.log(" this.sectionType",  this.columnKey);
    console.log("this.selectedparetawb", this.selectedparetawb);

    this.showModal = true
    this.getorigindetaildata(sectionType, columnKey, row.origin,this.pageNum1, this.rowhubid )
  },

  getorigindetaildata(columnKey,sectionType, origin,pageNum1, rowhubid ){
    // console.log(columnKey,sectionType, origin,pageNum1, rowhubid);
    
    // alert()
  const obj = {
    hub_id: this.valueWHhub,
    warehouseid: this.valueWH,
    edd: this.filters.edd,
    shipmentjourney: this.filters.journey,
    keyword: columnKey,
    type:sectionType,
    origin: origin,
    page_no: pageNum1,
    currenthubid:rowhubid,
    parentawb:this.selectedparetawb
  };
  
  // if(columnKey == 'firstmile' || columnKey == 'rtomovement' ){
  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getorigindetaildata`, obj)
    .then(result => {
      if (result.data.returnmsg === 'Successful') {
        this.awbData = result.body.returnvalue
        this.totalRowsmodal = result.body.returnvalue[0].totalcount
        this.noofpagesmodal=parseInt(this.totalRowsmodal)/10;
        this.noofpagesmodal=Math.ceil( this.noofpagesmodal);
      }
      else{
        this.awbData = []
        this.totalRowsmodal=0
      }
    });
  // }
  // else{
  //   // getmovementdataaccordingtocount
  //    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmovementdataaccordingtocount`, obj)
  //   .then(result => {
  //     if (result.data.returnmsg === 'Successful') {
  //       this.awbData = result.body.returnvalue.finaldata
  //       this.totalRowsmodal = result.body.returnvalue[0].totalcount
  //       this.noofpagesmodal=parseInt(this.totalRowsmodal)/10;
  //       this.noofpagesmodal=Math.ceil( this.noofpagesmodal);
  //     }
  //     else{
  //       this.awbData = []
  //       this.totalRowsmodal=0
  //     }
  //   });
  // }
    
  },

  getwarehousedetails(){
    
    const obj={
        userType: this.userType,
        sysusermasterid: this.Usersysuserid
    }
    
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getwarehousedetails`, obj)
    .then(result => {

    // console.log("ok")
  this.optionsWH=[];
            this.WHData = result.body.returnvalue;
            for (let j = 0; j < this.WHData.length; j++) {
                let WH = {
                    name:this.WHData[j].custvendorname,
                    id: this.WHData[j].warehouseid,
                };
                this.optionsWH.push(WH);
            }

            // console.log(" this.optionsWH",  this.optionsWH);
            

    })
  },

  showWHlist:function(){

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)

    var csvObj = {
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype:`${userInfo.user_type}`
    };
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListforoperationaldashboard`, csvObj)
        .then(result => {
        
        if (result.body.returnmsg === 'Successful') {
        
            this.WHDatahub  = result.body.returnvalue;
            
            for(let j = 0; j < this.WHDatahub.length; j++) {
                let WH = {
                name: this.WHDatahub[j].hub_title + " - " + this.WHDatahub[j].hub_id,
                id: this.WHDatahub[j].hub_id,
                }
            this.optionsWHhub.push(WH);
            }
        
        } else {              
            this.WHDatahub  = result.body.returnvalue;
        }


    })
    .catch(ex => {
        // console.log("error-----", ex);
    });
  },

  getdashboarddeliverycount() {

    const dashobj = {
      is_asn: this.route_id === 'normal' ? 'NO' : 'YES',
      status: this.$route.query.status || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey
    };

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAwbDelievryCountOPdashboard`, dashobj)
      .then(result => {

        let count = 0;

        if (result.data.returnmsg === 'Successful') {
          if (
            result.data.returnvalue &&
            result.data.returnvalue.ParentAWB &&
            result.data.returnvalue.ParentAWB.Delivered
          ) {
            count = result.data.returnvalue.ParentAWB.Delivered;
          }
        }

        const index = this.summaryList.findIndex(
          item => item.key === "TodaysDelivered"
        );

        if (index !== -1) {
          this.summaryList[index].value = count;
        }

      })
      .catch(() => {

        const index = this.summaryList.findIndex(
          item => item.key === "TodaysDelivered"
        );

        if (index !== -1) {
          this.summaryList[index].value = 0;
        }

      });
  },

  getdashboardreturnjourneycount() {

    const dashobj = {
      is_asn: this.route_id === 'normal' ? 'NO' : 'YES',
      status: this.$route.query.status || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey
    };

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getdashboardreturnjourneycount`, dashobj)
      .then(result => {

        let count = 0;

        if (result.data.returnmsg === 'Successful') {
          if (
            result.data.returnvalue &&
            result.data.returnvalue.ParentAWB &&
            result.data.returnvalue.ParentAWB.Delivered
          ) {
            count = result.data.returnvalue.ParentAWB.Delivered;
          }
        }

        const index = this.summaryList.findIndex(
          item => item.key === "TodayinReturnJourney"
        );

        if (index !== -1) {
          this.summaryList[index].value = count;
        }
        // this.keyword = "TodayinReturnJourney"
        this.getshipementcountfortodayreturnjourney(this.keyword = "TodayinReturnJourney");

      })
      .catch(() => {

        const index = this.summaryList.findIndex(
          item => item.key === "TodayinReturnJourney"
        );

        if (index !== -1) {
          this.summaryList[index].value = 0;
        }

      });
  },

  getshipementcountfortodaydelivery() {
    // alert(this.keyword)
    
    this.loader=true;
    const obj={
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: this.keyword
    }

  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshipementcountfortodaydelivery`, obj)
    .then(result => {
      this.loader=false;
      if (result.data.returnmsg === 'Successful') {

              const counts = result.data.returnvalue;
              // Convert to map: { hub_id: count }
              this.hubCountMap = {};

              counts.forEach(item => {
                this.hubCountMap[String(item.currenthubid)] = Number(item.total_count);
              });

              this.prepareHubList();
      }else{
        this.hubList =[]
      }
    });
  },


  getshipementcountfortodayreturnjourney(keyword){
     this.loader=true;
    const obj={
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: keyword
    }

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshipementcountfortodayreturnjourney`, obj)
      .then(result => {
        this.loader=false;
        if (result.data.returnmsg === 'Successful') {
            this.hubList = result.data.returnvalue
            .map(hub => {

              return {
                name: hub.shipmentstatus,
                count: hub.count || 0,
                id: hub.shipmentstatus
              };
            })
            

            const order = [
                "RTO",
                "RTO HubInScan",
                "RTO ZoneInScan",
                "RTO ZoneOutScan",
                "RTO Dispatch OutScan",
                "RTO OFD",
                "RTO InTransit",
                "RTO Delivered"
              
              ];

            const mappedMetrics = order.map(status => {
            const found = this.hubList.find(f => f.name === status);
            return {
              label: status,
              value: found ? Number(found.count) : 0
            };
          });

          // Bind to firstmile section
          const firstmileSection = this.sections.find(s => s.type === "rtomovement");
          if (firstmileSection) {
            firstmileSection.metrics = mappedMetrics;
          }
        
        }
      });
  },

  prepareHubList() {
    if (!this.WHDatahub || Object.keys(this.hubCountMap).length === 0) return;

    this.hubList = this.WHDatahub
      .map(hub => {
        const hubId = String(hub.hub_id);

        return {
          name: hub.hub_title,
          count: this.hubCountMap[hubId] || 0,
          id: hub.hub_id
        };
      })
      .filter(hub => hub.count > 0); //  remove zero count

    // console.log("FINAL LIST:", this.hubList);
  },

  getcitywisecounttodaydelivery(hubid) {
    this.loader=true;
    this.citywisedata = []; // reset before filling
    if(this.keyword == 'TodaysDelivered'){
      const obj = {
      hub_id: hubid,
      warehouseid: this.valueWH,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: this.keyword
    };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getcitywiseshipementcountfortodaydelivery`, obj)
        .then(result => {
          this.loader=false;
          if (result.data.returnmsg === 'Successful') {

            const citydata = result.data.returnvalue;

            for (let j = 0; j < citydata.length; j++) {
              let WH = {
                name: citydata[j].destinationcity,
                count: Number(citydata[j].shipment_count)
              };
              this.citywisedata.push(WH);
            }

          } else {
            this.citywisedata = [];
          }

        });
    }
    else if(this.keyword == 'TodayinReturnJourney'){
      this.loader=true;
     const obj = {
      hub_data: hubid,
      hub_id: this.valueWHhub,
      warehouseid: this.valueWH,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: this.keyword
    };
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/gethubdetailsforreturnjoury`, obj)
    .then(result => {
      this.loader=false;
      if (result.data.returnmsg === 'Successful') {

        const citydata = result.data.returnvalue;

        // Create lookup map from WHDatahub
        const hubMap = {};
        this.WHDatahub.forEach(hub => {
          hubMap[String(hub.hub_id)] = hub.hub_title;
        });

        this.citywisedata = []; // reset

        for (let j = 0; j < citydata.length; j++) {

          const rawHubId = citydata[j].currenthubid;

          //  Proper null/empty check (FIXED)
          if (rawHubId === null || rawHubId === undefined || rawHubId === '') {
            continue;
          }

          const hubId = String(rawHubId);

          let WH = {
            name: hubMap[hubId] || hubId,
            count: Number(citydata[j].total_count),
            id: hubId
          };

          this.citywisedata.push(WH);
        }

      } else {
        this.citywisedata = [];
      }

    });
    }
  },


  preparehublistforreturnjouney() {
    if (!this.WHDatahub || !this.citywisedata) return;

    // Step 1: Create map from citywisedata
    const hubCountMap = {};

    this.citywisedata.forEach(item => {
      if (item.currenthubid !== null) {
        hubCountMap[String(item.currenthubid)] = Number(item.total_count);
      }
    });

    // Step 2: Map WHDatahub with counts
    this.citywisedatafinal = this.WHDatahub
      .map(hub => {
        const hubId = String(hub.hub_id);

        return {
          id: hub.hub_id,
          name: hub.hub_title,
          count: hubCountMap[hubId] || 0
        };
      })
      .filter(hub => hub.count > 0); // only show hubs with data

    // console.log("Final Data:", this.citywisedatafinal);
  },

  getfirstmiletodayscount(){
     const dashobj = {
      // is_asn: this.route_id === 'normal' ? 'NO' : 'YES',
      status: this.$route.query.status || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey
    };

    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getfirstmiletodayscount`, dashobj)
        .then(result => {

        let count = 0;

        if (result.data.returnmsg === 'Successful') {
          if (
            result.data.returnvalue &&
            result.data.returnvalue.ParentAWB &&
            result.data.returnvalue.ParentAWB.Delivered
          ) {
            count = result.data.returnvalue.ParentAWB.Delivered;
          }
        }

        const index = this.summaryList.findIndex(
          item => item.key === "Todayinfirstfile"
        );

        if (index !== -1) {
          this.summaryList[index].value = count;
        }

        this.getfirstmileshipmentcountdetails(this.keyword= "Todayinfirstfile");

      })
      .catch(() => {

        const index = this.summaryList.findIndex(
          item => item.key === "Todayinfirstfile"
        );

        if (index !== -1) {
          this.summaryList[index].value = 0;
        }

      });
    
  },

  async getmidmiletodayscount() {
    try {
      const dashobj = {
        status: this.$route.query.status || '',
        sysusermasterid: this.Usersysuserid,
        warehouseid: this.valueWH,
        hub_id: this.valueWHhub,
        edd: this.filters.edd,
        shipmentjourney: this.filters.journey
      };

      const { data } = await this.$http.post(
        `${CONSTANTS.MISREPORT_API_URL}/getmidmiletodayscount`,
        dashobj
      );

      if (data.returnmsg !== 'Successful') return;

      const res = data.returnvalue || {};

      //ONLY MIDMILE
      this.midmileData = res.midmile || [];
      const midmileTotal = res.midmiletotal || 0;

      const summaryMap = {};
      this.summaryList.forEach(item => {
        summaryMap[item.key] = item;
      });

      //Update ONLY midmile total
      if (summaryMap["TodayinMidMile"]) {
        summaryMap["TodayinMidMile"].value = midmileTotal;
      }

      // OPTIONAL: status mapping
      this.midmileData.forEach(status => {
        const key = `MidMile-${status.status_name}`;
        if (summaryMap[key]) {
          summaryMap[key].value = status.status_count;
        }
      });

      // Graph section
        const order = [
          "INTransit",
          "HubInScan",
          "ZoneInScan/DockInScan",
          "ZoneOutScan/DockOutScan",
          "DispatchOutScan"
        ];

        const labelMap = {
          "ZoneInScan/DockInScan": "ZoneInScan",
          "ZoneOutScan/DockOutScan": "ZoneOutScan"
        };

        const mappedMetrics = order.map(status => {
          const found = this.midmileData.find(
            f => f.status_name === status
          );

          return {
            label: labelMap[status] || status, // rename here
            value: found ? Number(found.status_count) : 0
          };
        });

        const midmilesection = this.sections.find(s => s.type === "midmile");

        if (midmilesection) {
          this.$set(midmilesection, "metrics", mappedMetrics);
        }
    } catch (error) {
      // console.error("API Error:", error);

      const summaryMap = {};
      this.summaryList.forEach(item => {
        summaryMap[item.key] = item;
      });

      if (summaryMap["TodayinMidMile"]) {
        summaryMap["TodayinMidMile"].value = 0;
      }
    }
  },

  async getlastmiletodayscount() {
    try {
      const dashobj = {
        status: this.$route.query.status || '',
        sysusermasterid: this.Usersysuserid,
        warehouseid: this.valueWH,
        hub_id: this.valueWHhub,
        edd: this.filters.edd,
        shipmentjourney: this.filters.journey
      };

      const { data } = await this.$http.post(
        `${CONSTANTS.MISREPORT_API_URL}/getlastmiletodayscount`,
        dashobj
      );

      if (data.returnmsg !== 'Successful') return;

      const res = data.returnvalue || {};

      //  ONLY LASTMILE
      this.lastmileData = res.lastmile || [];
      const lastmileTotal = res.lastmiletotal || 0;

      const summaryMap = {};
      this.summaryList.forEach(item => {
        summaryMap[item.key] = item;
      });

      // Update ONLY lastmile total
      if (summaryMap["TodayinLastMile"]) {
        summaryMap["TodayinLastMile"].value = lastmileTotal;
      }

      // OPTIONAL: status mapping
      this.lastmileData.forEach(status => {
        const key = `LastMile-${status.status_name}`;
        if (summaryMap[key]) {
          summaryMap[key].value = status.status_count;
        }
      });

      // Graph section (if you have lastmile section)
        const order = [
          "HubInScan",
          "ZoneInScan/DockInScan",
          "ZoneOutScan/DockOutScan",
          "DispatchOutScan",
          "OFD",
          "NDR",
          "Partial Delivered"
        ];

        const labelMap = {
          "ZoneInScan/DockInScan": "ZoneInScan",
          "ZoneOutScan/DockOutScan": "ZoneOutScan"
        };

        const mappedMetrics = order.map(status => {
          const found = this.lastmileData.find(f => f.status_name == status);

          return {
            label: labelMap[status] || status,  // rename here
            value: found ? Number(found.status_count) : 0
          };
        });

        const lastmilesection = this.sections.find(s => s.type == "lastmile");

        if (lastmilesection) {
          this.$set(lastmilesection, "metrics", mappedMetrics);
        }
    } catch (error) {
      // console.error("API Error:", error);

      const summaryMap = {};
      this.summaryList.forEach(item => {
        summaryMap[item.key] = item;
      });

      if (summaryMap["TodayinLastMile"]) {
        summaryMap["TodayinLastMile"].value = 0;
      }
    }
  },

  getfirstmileshipmentcountdetails(keyword){
    this.loader=true;
    // alert();
     const obj={
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: keyword
    }

  this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getfirstmileshipmentcountdetails`, obj)
    .then(result => {
      this.loader=false;
      if (result.data.returnmsg === 'Successful') {
        this.firstfilecount = result.data.returnvalue
          .map(ft => {

            return {
              name: ft.shipmentstatus,
              count: ft.count || 0,
              id: ft.shipmentstatus
            };
          })


        const order = [
          "BookingPending",
          "BookingDone",
          "HubInScanPending",
          "PickDone",
          "NPR"
        ];

        const mappedMetrics = order.map(status => {
          const found = this.firstfilecount.find(f => f.name === status);
          return {
            label: status,
            value: found ? Number(found.count) : 0
          };
        });

        // Bind to firstmile section
        const firstmileSection = this.sections.find(s => s.type === "firstmile");
        if (firstmileSection) {
          firstmileSection.metrics = mappedMetrics;
        }
      }
    })

  },

  getintransitcount(){
     this.loader=true;
     const obj={
      warehouseid: this.valueWH ,
      hub_id: this.valueWHhub,
      edd: this.filters.edd ,
      shipmentjourney: this.filters.journey,
      keyword: this.keyword
    }
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getintransitcount`, obj)
    .then(result => {
      this.loader=false;
      if (result.data.returnmsg === 'Successful') {
        this.intransitcount = result.data.returnvalue[0]
      }
      else{
        this.intransitcount=[]
      }
    })

  },

  getorigindetailCsvdata(){

    const params = new URLSearchParams({
      hub_id: this.valueWHhub || '',
      warehouseid: this.valueWH || '',
      edd: this.filters.edd || '',
      shipmentjourney: this.filters.journey || '',
      keyword: this.sectionType  || '',
      type: this.columnKey  || '',
      origin: this.roworigin || '',
      currenthubid: this.rowhubid  || '',
      parentawb: Array.isArray(this.selectedparetawb)
        ? this.selectedparetawb.join(",")
        : ''
    });

    this.loadurl = `${CONSTANTS.MISREPORT_API_URL}/getorigindetailCsvdata?${params.toString()}`;

    //  trigger download (ONLY href, no download attr)
    const link = document.createElement('a');
    link.href = this.loadurl;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // loader stop (approx)
    setTimeout(() => {
        this.loader = false;
    }, 3000);

    this.showModal = false
  }

  

  }
}
</script>

<style scoped>
.summary-box {
  background-color: #17a2b8;
  color: white;
  padding: 15px;
  border-radius: 8px;
  height: 100%;
}

.title {
  font-weight: bold;
  font-size: 14px;
}

.shipment-box {
  background-color:  #17a2b8;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #999;
}

.shipment-box .title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.shipment-box .value {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
}
.clickable {
  cursor: pointer;
  transition: 0.2s;
}

.clickable:hover {
  transform: scale(1.02);
}

.hub-section {
  background: #f1f1f1;
  padding: 15px;
  border-radius: 8px;
}

.hub-box {
  background: #d3d3d3;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #888;
  cursor: pointer;
}

.hub-title {
  font-weight: bold;
  font-size: 13px;
}

.hub-value {
  font-size: 18px;
  font-weight: bold;
}
.overallproctshipment{
    padding-bottom: 20px;
    border-bottom: 2px solid grey;
}
.top-tile {
  background: #c9c3e6;
  padding: 15px;
  border-radius: 8px;
  font-weight: bold;
}

.tile-value {
  font-size: 22px;
}

.count-box {
  background: #eee;
  padding: 8px;
  border-radius: 5px;
}

.count {
  color: blue;
  font-weight: bold;
}

.clickable {
  cursor: pointer;
}
.accordion-row {
  display: flex;
  align-items: center;
  background: #e6e6e6;
  border: 1px solid #999;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 6px;
}

.left-section {
  width: 220px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
   font-weight: bold;
}

.right-section {
  display: flex;
  flex: 1;
  justify-content: space-around;
}

.count-box-inline {
  text-align: center;
  min-width: 100px;
}

.metric-title {
  font-size: 12px;
}

.metric-value {
  font-weight: bold;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: #dff0d8;
}

.custom-table th,
.custom-table td {
  border: 1px solid #999;
  padding: 6px;
  text-align: center;
}

.clickable1 {
  cursor: pointer;
  color: blue;
  font-weight: bold;
}
.hub-scroll-container {
  max-height: 300px;   /* adjust as needed */
  overflow-y: auto;    /* vertical scroll */
  overflow-x: hidden;  /* no horizontal scroll */
  padding-right: 5px;  /* optional (for scrollbar spacing) */
}
</style>